import type { ITeamRepository } from "@/core/repositories/interfaces/ITeamRepository";
import type { UpdateTeamMemberInput } from "@/core/repositories/interfaces/ITeamRepository";
import type { CreateTeamMemberInput } from "@/core/repositories/interfaces/ITeamRepository";
import type { ITeamService } from "@/core/services/interfaces/ITeamService";
import type { TeamMember } from "@/core/services/types/team.types";

export class TeamService implements ITeamService {
  constructor(private readonly repository: ITeamRepository) {}

  async listAll(): Promise<TeamMember[]> {
    return this.repository.findAll();
  }

  async createMember(input: CreateTeamMemberInput): Promise<TeamMember | null> {
    if (!input.first_name.trim() || !input.last_name.trim() || !input.email.trim()) {
      return null;
    }

    return this.repository.create(input);
  }

  async deleteMember(id: string): Promise<boolean> {
    if (!id.trim()) return false;
    return this.repository.delete(id);
  }

  async updateMember(
    id: string,
    input: UpdateTeamMemberInput,
  ): Promise<TeamMember | null> {
    if (!id.trim()) return null;
    return this.repository.update(id, input);
  }
}
